import React from 'react';
import styled, { keyframes } from 'styled-components';
import {
  Carousel,
  Grid,
  Row,
  Col,
} from 'react-bootstrap';

const HEIGHT = '450px'

const slideIn = keyframes`
  from {
    height: 0px;
  }
  to {
    height: ${HEIGHT}
  }
`;

const slideOut = keyframes`
  from {
    height: ${HEIGHT};
  }
  to {
    height: 0px;
  }
`;

const ThisCarousel = styled(Carousel)`
  background-color: #e9e9e9;
  overflow: hidden;

  padding: 0 40px;
  @media (min-width: 768px) {
    padding: 0;
  }

  animation: ${slideIn} 1s ease-in-out forwards;

  &.dismissed {
    animation: ${slideOut} 1s ease-in-out forwards;
  }

  .item {
    height: ${HEIGHT};
  }

  .carousel-indicators {
    top: 20px;
    bottom: auto;

    li {
      border: 1px solid #00AD83;
    }

    li.active {
      background-color: #00AD83;
    }
  }

  .carousel-control {
    display: none;
  }

  .carousel-caption {
    text-align: left;
    bottom: auto;
    left: 0;
    top: 70px;
  }

`;

const Image = styled.div`
  position: absolute;
  width: 100%;
  height: ${HEIGHT};
  background-image: url(${props => props.src});
  background-position: center;
  background-repeat: no-repeat;
  display: none;

  @media (min-width: 768px) {
    display: block;
  }
`;

const Step = styled.div`
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #222;
  font-weight: 700;
  text-shadow: none;
`;

const Title = styled.div`
  padding: 15px 0;
  text-shadow: none;
  font-weight: bold;
  color: #444;
  font-size: 25px;
  line-height: 45px;


  @media (min-width: 768px) {
    font-size: 35px;
    line-height: 45px;
  }

  @media (min-width: 992px) {
    font-size: 45px;
    line-height: 55px;
  }
`;

const Description = styled.div`
  text-shadow: none;
  color: #999;

  font-size: 16px;

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;

const Link = styled.a`
  display: inline-block;
  margin-top: 20px;
  margin-right: 20px;
  padding: 12px 20px;
  border: none;
  background-color: #00AD83;
  font-size: 12px;
  font-weight: 700;
  color: white;
  box-shadow: 0px 3px 3px rgba(0,0,0,.1);
  text-shadow: none;

  :hover, :active, :focus {
    text-decoration:none;
    color: white;
    background-color: #059874;
  }
`

const PreviousLink = styled(Link)`
  background-color: white;
  color: #00AD83;

  :hover, :active, :focus {
    text-decoration:none;
    color: #00AD83;
    background-color: #efefef;
    cursor: pointer;
  }
`;

const NextLink = styled(Link)`
  background-color: white;
  color: #00AD83;

  :hover, :active, :focus {
    text-decoration:none;
    color: #00AD83;
    background-color: #efefef;
    cursor: pointer;
  }
`;

const DismissLink = styled(Link)`
  background-color: white;
  color: #00AD83;

  :hover, :active, :focus {
    text-decoration:none;
    color: #00AD83;
    background-color: #efefef;
    cursor: pointer;
  }
`;

const TextLink = styled.a`
  color: #00AD83;

  :hover, :active, :focus {
    color: #00AD83;
  }
`;

class Onboarding extends React.Component {

  state = {
    index: 0,
    direction: null,
    isDismissed: false,
  };

  handleSelect = (selectedIndex, e) => {
    this.setState({
      index: selectedIndex,
      direction: e.direction
    });
  }

  goToNext = (e) => {
    e.preventDefault();
    this.handleSelect(this.state.index+1, {
      direction: 'next',
    });
  }

  goToPrevious = (e) => {
    e.preventDefault();
    this.handleSelect(this.state.index-1, {
      direction: 'prev',
    });
  }

  dismiss = () => {
    this.setState({
      isDismissed: true,
    });
  }

  render() {
    return (
      <ThisCarousel
        className={this.state.isDismissed ? "dismissed" : "active"}
        interval={null}
        activeIndex={this.state.index}
        direction={this.state.direction}
        onSelect={this.handleSelect}>

        <Carousel.Item>
          <Image src="/images/onboarding-1-metamask.png" />
          <Grid>
            <Row>
              <Col xs={12} sm={6}>
                <Carousel.Caption>
                  <Step>Step 1:</Step>
                  <Title>Add MetaMask to your browser</Title>
                  <Description>
                    You’ll use MetaMask to make secure ether (ETH) transactions from your browser.&nbsp;
                    <TextLink href="https://metamask.io/" target="_blank">Get MetaMask.</TextLink>
                  </Description>
                  <NextLink onClick={this.goToNext}>Next step</NextLink>
                </Carousel.Caption>
              </Col>
            </Row>
          </Grid>
        </Carousel.Item>

        <Carousel.Item>
          <Image src="/images/onboarding-2-coinbase.png" />
          <Grid>
            <Row>
              <Col xs={12} sm={6}>
                <Carousel.Caption>
                  <Step>Step 2:</Step>
                  <Title>Buy ether (ETH)</Title>
                  <Description>
                    You’ll need to set up an account on an exchange. Coinbase is one of many where you can buy, sell, and manage digital currencies.&nbsp;
                    <TextLink href="https://coinbase.com/signup/?r=52ffccb44bff97a306000031" target="_blank">Go to Coinbase.</TextLink>
                  </Description>
                  <PreviousLink onClick={this.goToPrevious}>Go Back</PreviousLink>
                  <NextLink onClick={this.goToNext}>Next step</NextLink>
                </Carousel.Caption>
              </Col>
            </Row>
          </Grid>
        </Carousel.Item>

        <Carousel.Item>
          <Image src="/images/onboarding-3-sendeth.png" />
          <Grid>
            <Row>
              <Col xs={12} sm={6}>
                <Carousel.Caption>
                  <Step>Step 3:</Step>
                  <Title>Send ether to your MetaMask</Title>
                  <Description>
                    Copy your MetaMask address, go to your accounts on Coinbase, and send ether to your address.&nbsp;
                    <TextLink href="https://support.coinbase.com/customer/en/portal/articles/971437-how-do-i-send-digital-currency-to-another-wallet-" target="_blank">Get help.</TextLink>
                  </Description>
                  <PreviousLink onClick={this.goToPrevious}>Go back</PreviousLink>
                  <NextLink onClick={this.goToNext}>Next step</NextLink>
                </Carousel.Caption>
              </Col>
            </Row>
          </Grid>
        </Carousel.Item>

        <Carousel.Item>
          <Image src="/images/onboarding-4-play.png" />
          <Grid>
            <Row>
              <Col xs={12} sm={6}>
                <Carousel.Caption>
                  <Step>Step 4:</Step>
                  <Title>Bid on a card</Title>
                  <Description>
                    Go to new cards and enter the ether amount you want to bid. Confirm your transaction in MetaMask. (Note: Gas price determines how fast your bid will be placed. <TextLink href="https://www.youtube.com/watch?v=QwG8Ze2oP6E" target="_blank">Learn more here.</TextLink>)
                  </Description>
                  <PreviousLink onClick={this.goToPrevious}>Go back</PreviousLink>
                  <DismissLink onClick={this.dismiss}>Got It</DismissLink>
                </Carousel.Caption>
              </Col>
            </Row>
          </Grid>
        </Carousel.Item>

      </ThisCarousel>
    );
  }

}

export default Onboarding;



// WEBPACK FOOTER //
// ./src/components/ui/OnboardingUI.js